export const SET_EDITOR = 'SET_EDITOR'
export const SET_CONTENT_SET = 'set-content-set'
export const SET_CONTENT = 'set-content'
export const SET_TEMPLATE = 'set-template'

export const SET_LEFT_SIDE_STATE = 'set-left-side-state'
export const SET_RIGHT_SIDE_STATE = 'set-right-side-state'

export const SET_EDITOR_CANVAS_VIEW = 'set-editor-canvas-view'
export const SET_EDITOR_SORTER_ACTIVE = 'set-editor-sorter-active'

export const INCREASE_EDITOR_LOADING_COUNTER = 'increase-editor-loading-counter'
export const DECREASE_EDITOR_LOADING_COUNTER = 'decrease-editor-loading-counter'
export const SET_CANVAS_CHANGES_COUNT = 'set-canvas-changes-count'
export const SET_CANVAS_SELECTED_COMPONENT = 'set-canvas-selected-component'
export const SET_AUTOSAVE_ENABLED = 'set-autosave-enabled'
export const SET_AUTOSAVED = 'set-autosaved'

export const SET_VIEW_CANVAS_GRID = 'set-view-canvas-grid'

export const SET_BUILDER_OPTIONS = 'set-builder-options'
export const SET_EDITOR_OPTIONS = 'set-editor-options'
export const SET_BUILDER_APP = 'set-builder-app'
export const SET_BUILDER = 'set-builder'
export const SET_SERVICE_MANAGER = 'set-service-manager'
